(() => {
  const init = (v) => {
    if (v.dataset.replayBound) return;
    v.dataset.replayBound = '1';
    new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) v.play().catch(() => {});
        else v.pause();
      }
    }, { threshold: 0.5 }).observe(v);
  };

  const scan = (root = document) =>
    root.querySelectorAll('video.product-media-video').forEach(init);

  scan();
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();